import {
  BulkAction,
  Dialog,
  Pagination,
  SingleAction,
  Sort,
  TabActionDialog
} from "@saleor/types";
import { stringify as stringifyQs } from "qs";
import urlJoin from "url-join";

export const inslabelSection = "/inslabel/";

export const inslabelListPath = inslabelSection;

export const inslabelListUrl = (params?: InslabelListUrlQueryParams) =>
  inslabelListPath + "?" + stringifyQs(params);

export type InslabelListUrlDialog = "remove" | "add" | TabActionDialog;

export type InslabelListUrlSort = Sort<InslabelListUrlSortField>;

export type InslabelListUrlQueryParams = SingleAction &
  BulkAction &
  InslabelListUrlSort &
  Dialog<InslabelListUrlDialog> &
  Pagination;

export enum InslabelListUrlSortField {
  name = "name"
}

export type InstagramLabelUrlDialog = "remove" | "remove-labelins" | "assign";

export type InstagramLabelPathUrlQueryParams = BulkAction &
  Dialog<InstagramLabelUrlDialog> &
  SingleAction &
  Pagination;

export const inslabelPath = (id: string) => urlJoin(inslabelSection, id);

export const inslabelUrl = (
  id: string,
  params?: InstagramLabelPathUrlQueryParams
) => inslabelPath(encodeURIComponent(id)) + "?" + stringifyQs(params);
